import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';

const About = () => {
  const { themeConfig } = useTheme();
  const { about } = themeConfig;

  return (
    <section id="story" className="py-20 px-6 bg-cream">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h2 className="text-4xl md:text-5xl font-playfair text-warm-brown mb-6">
              {about.title}
            </h2>
            {about.paragraphs.map((paragraph, index) => (
              <p key={index} className="text-lg text-warm-brown/80 leading-relaxed">
                {paragraph}
              </p>
            ))}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img
              src={about.image}
              alt="La Vie Saigon kitchen workspace"
              className="rounded-lg shadow-2xl w-full h-96 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-warm-brown/20 to-transparent rounded-lg" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;